import { css } from '@emotion/css';

const dropdownStyles = css`
  width: 90%;

  .MuiInputBase-input {
    padding: 8.5px 14px;
  }
`;

export default { dropdownStyles };
